module.exports = "/fast-coin/img/coin/anim/out_2/out_2_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_005.png
// module id = 2311
// module chunks = 5